export enum TemplateEnum
{
    PadrãoAdminReport = 3,
}